import React from 'react';
import { motion } from 'framer-motion';
import { ScaleIcon, XIcon } from 'lucide-react';
import { costs } from '../data/problems';
export function CostSection() {
  return <section className="bg-stage py-16 sm:py-20" aria-labelledby="cost-title" data-id="element-63" data-mp="4l7ys24ll3kh">
      <div className="mx-auto max-w-4xl px-4" data-id="element-64" data-mp="4j4y8o5tjs1i">
        <div className="text-center" data-id="element-65" data-mp="3vsapytkfr9up">
          <ScaleIcon className="mx-auto h-9 w-9 text-gold" data-id="element-66" data-mp="3vr94rw9ph6z9" />
          <h2 id="cost-title" className="mt-4 text-3xl font-extrabold text-white sm:text-4xl" data-id="element-67" data-mp="3qsoaedh4xhiq">El costo de no tenerlo</h2>
          <p className="mt-3 text-mutedDark" data-id="element-68" data-mp="3mp9k8tzhfkrk">Lo que realmente perdés cada ciclo lectivo sin el Megapack</p>
        </div>

        <div className="mt-10 space-y-2" data-id="element-69" data-mp="3htu9iawru4zd">
          {costs.map(([without, loss], index) => <motion.div key={without} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.03,
          ease: [0.23, 1, 0.32, 1]
        }} className="panel-dark grid gap-2 rounded-xl border border-lineDark p-4 sm:grid-cols-[minmax(0,1fr)_minmax(0,1.6fr)] sm:gap-6" data-id="element-70" data-mp="3cuhprz175e10" data-mpi={index}>
              <p className="flex items-start gap-2 text-sm font-bold text-white" data-id="element-71" data-mp="f9ni5qw9pcma">
                <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-mutedDark" data-id="element-72" data-mp="fbqdmqg6vxye" />
                {without}
              </p>
              <p className="text-sm leading-relaxed text-mutedDark" data-id="element-73" data-mp="17yb47oouc60w">{loss}</p>
            </motion.div>)}
        </div>

        <blockquote className="panel-dark mt-10 rounded-2xl border border-gold/35 p-6 text-center text-sm font-semibold leading-relaxed text-onDark sm:p-8" data-id="element-74" data-mp="1cw4fgw503q81">
          “La próxima vez que un alumno pregunte para qué sirve estudiar Museología, podés mostrarle que Argentina tiene museos
          donde el patrimonio es el corazón del aprendizaje, que existen museólogos que están preservando memoria en contextos
          de vulnerabilidad, que la mediación educativa puede cambiar trayectorias, que la inclusión se construye desde el
          museo, y que cada iniciativa de acceso al patrimonio es un acto de resistencia contra la desigualdad. O podés seguir
          explicando sin ese contexto.”
        </blockquote>
      </div>
    </section>;
}